import React from 'react';
import Header from '../components/layout/header';
import './home.css'
import Footer from '../components/layout/footer';
import Sec8 from '../components/layout/section8';
import Sec9 from '../components/layout/section9';
import Sec10 from '../components/layout/section10';
const Villas = () => {
    return ( <>

        <body className='bodyyy'>
        <main>
            <Header />

            <Sec8 />

            <Sec9 />
            <Sec10 />

            <Footer />
            </main>
        </body>


    </> );
}
 
export default Villas;

